exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.disabled {\r\n    opacity: 0.5;\r\n    cursor: default;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/add-exchange-student-modal/add-exchange-student-modal.component.css
// module id = ../../../../../src/app/layout/modules/admin/programme/programme-details/modals/add-exchange-student-modal/add-exchange-student-modal.component.css
// module chunks = main